/* !!! This is code generated by Prisma. Do not edit directly. !!! */
/* eslint-disable */
// biome-ignore-all lint: generated file
// @ts-nocheck
/*
 * This file exports all enum related types from the schema.
 *
 * 🟢 You can import this file directly.
 */

export const ActionAutoTriggerType = {
  A2B_FULFILLMENT_WEBHOOK: 'A2B_FULFILLMENT_WEBHOOK',
  ADD_ROW: 'ADD_ROW',
  AIRTABLE_WEBHOOK: 'AIRTABLE_WEBHOOK',
  AMAZON_SELLER_WEBHOOK: 'AMAZON_SELLER_WEBHOOK',
  BILL_WEBHOOK: 'BILL_WEBHOOK',
  CARTONCLOUD_WEBHOOK: 'CARTONCLOUD_WEBHOOK',
  DELETE_ROW: 'DELETE_ROW',
  DEMO: 'DEMO',
  DOSS_BANKING_WEBHOOK: 'DOSS_BANKING_WEBHOOK',
  DOSS_BILL_PAY_WEBHOOK: 'DOSS_BILL_PAY_WEBHOOK',
  EASYPOST_WEBHOOK: 'EASYPOST_WEBHOOK',
  EXTENSIV_WEBHOOK: 'EXTENSIV_WEBHOOK',
  FENO_WEBHOOK: 'FENO_WEBHOOK',
  FIRSTBASE_WEBHOOK: 'FIRSTBASE_WEBHOOK',
  FLEXPORT_WEBHOOK: 'FLEXPORT_WEBHOOK',
  FORM_SUBMIT: 'FORM_SUBMIT',
  FORM_V2_SUBMIT: 'FORM_V2_SUBMIT',
  FORTY_SEAS_WEBHOOK: 'FORTY_SEAS_WEBHOOK',
  GMAIL_WEBHOOK: 'GMAIL_WEBHOOK',
  GNOSIS_WEBHOOK: 'GNOSIS_WEBHOOK',
  GOFREIGHT_WEBHOOK: 'GOFREIGHT_WEBHOOK',
  HUBSPOT_WEBHOOK: 'HUBSPOT_WEBHOOK',
  INGRAM_MICRO_WEBHOOK: 'INGRAM_MICRO_WEBHOOK',
  JAY_GROUP_WEBHOOK: 'JAY_GROUP_WEBHOOK',
  JAZZ_WEBHOOK: 'JAZZ_WEBHOOK',
  LAZADA_WEBHOOK: 'LAZADA_WEBHOOK',
  LOCAD_WEBHOOK: 'LOCAD_WEBHOOK',
  LOGIWA_WEBHOOK: 'LOGIWA_WEBHOOK',
  LOOP_RETURNS_WEBHOOK: 'LOOP_RETURNS_WEBHOOK',
  MAYA_WEBHOOK: 'MAYA_WEBHOOK',
  MINTSOFT_WEBHOOK: 'MINTSOFT_WEBHOOK',
  MISFITS_MARKET_WEBHOOK: 'MISFITS_MARKET_WEBHOOK',
  NAVISPHERE_WEBHOOK: 'NAVISPHERE_WEBHOOK',
  OUTLOOK_WEBHOOK: 'OUTLOOK_WEBHOOK',
  QUICKBOOKS_WEBHOOK: 'QUICKBOOKS_WEBHOOK',
  RILLET_WEBHOOK: 'RILLET_WEBHOOK',
  ROUTABLE_WEBHOOK: 'ROUTABLE_WEBHOOK',
  SALSIFY_WEBHOOK: 'SALSIFY_WEBHOOK',
  SHIPBOB_WEBHOOK: 'SHIPBOB_WEBHOOK',
  SHIPHERO_WEBHOOK: 'SHIPHERO_WEBHOOK',
  SHIPMONK_WEBHOOK: 'SHIPMONK_WEBHOOK',
  SHIPWIRE_WEBHOOK: 'SHIPWIRE_WEBHOOK',
  SHOPEE_WEBHOOK: 'SHOPEE_WEBHOOK',
  SHOPIFY_WEBHOOK: 'SHOPIFY_WEBHOOK',
  SILQ_WEBHOOK: 'SILQ_WEBHOOK',
  STORD_WEBHOOK: 'STORD_WEBHOOK',
  STRIPE_WEBHOOK: 'STRIPE_WEBHOOK',
  THINK_LOGISTICS_WEBHOOK: 'THINK_LOGISTICS_WEBHOOK',
  TIKTOK_SHOP_WEBHOOK: 'TIKTOK_SHOP_WEBHOOK',
  UPDATE_CELL: 'UPDATE_CELL',
  UPDATE_ROW: 'UPDATE_ROW',
  USA_SUPPLY_PORTAL_WEBHOOK: 'USA_SUPPLY_PORTAL_WEBHOOK',
  WALMART_WEBHOOK: 'WALMART_WEBHOOK',
  WOO_COMMERCE_WEBHOOK: 'WOO_COMMERCE_WEBHOOK',
} as const

export type ActionAutoTriggerType =
  (typeof ActionAutoTriggerType)[keyof typeof ActionAutoTriggerType]

export const ActionStatus = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
} as const

export type ActionStatus = (typeof ActionStatus)[keyof typeof ActionStatus]

export const ActionStepStatus = {
  ACTIVE: 'ACTIVE',
  FORCED_INACTIVE: 'FORCED_INACTIVE',
  INACTIVE: 'INACTIVE',
} as const

export type ActionStepStatus = (typeof ActionStepStatus)[keyof typeof ActionStepStatus]

export const ActionStepType = {
  AI_PROMPT: 'AI_PROMPT',
  API_RESPONSE: 'API_RESPONSE',
  ARRAY_SELECT: 'ARRAY_SELECT',
  BRANCH: 'BRANCH',
  BULK_UPSERT_TABLE_ROW: 'BULK_UPSERT_TABLE_ROW',
  DATASTORE_WRITE: 'DATASTORE_WRITE',
  DELAY: 'DELAY',
  DELETE_TABLE_ROW: 'DELETE_TABLE_ROW',
  DEMO: 'DEMO',
  FORMULA: 'FORMULA',
  GENERATE_BARCODE: 'GENERATE_BARCODE',
  GENERATE_FILE: 'GENERATE_FILE',
  GROUP_BY: 'GROUP_BY',
  GROUP_BY_MULTIPLE: 'GROUP_BY_MULTIPLE',
  INSERT_TABLE_ROW: 'INSERT_TABLE_ROW',
  MAP: 'MAP',
  MERGE: 'MERGE',
  MERGE_FILES: 'MERGE_FILES',
  NOTIFICATION: 'NOTIFICATION',
  PARSE_FILE: 'PARSE_FILE',
  READ_INTEGRATION: 'READ_INTEGRATION',
  SEND_EMAIL: 'SEND_EMAIL',
  TABLE_QUERY: 'TABLE_QUERY',
  UNIQUE_BY: 'UNIQUE_BY',
  UNIQUE_BY_MULTIPLE: 'UNIQUE_BY_MULTIPLE',
  UPDATE_TABLE_ROW: 'UPDATE_TABLE_ROW',
  WHILE: 'WHILE',
  WRITE_INTEGRATION: 'WRITE_INTEGRATION',
} as const

export type ActionStepType = (typeof ActionStepType)[keyof typeof ActionStepType]

export const ActionTriggerConcurrencyMode = {
  KEYED: 'KEYED',
  SEQUENTIAL: 'SEQUENTIAL',
} as const

export type ActionTriggerConcurrencyMode =
  (typeof ActionTriggerConcurrencyMode)[keyof typeof ActionTriggerConcurrencyMode]

export const ActionTriggerConcurrencyScope = {
  ACTION: 'ACTION',
  ORGANIZATION: 'ORGANIZATION',
  WORKFLOW: 'WORKFLOW',
} as const

export type ActionTriggerConcurrencyScope =
  (typeof ActionTriggerConcurrencyScope)[keyof typeof ActionTriggerConcurrencyScope]

export const AdminPermissionType = {
  DELETE_ORGANIZATIONS: 'DELETE_ORGANIZATIONS',
  MANAGE_ADMIN_USERS: 'MANAGE_ADMIN_USERS',
} as const

export type AdminPermissionType = (typeof AdminPermissionType)[keyof typeof AdminPermissionType]

export const AdminUserStatus = {
  ACTIVE: 'ACTIVE',
  DISABLED: 'DISABLED',
  INVITED: 'INVITED',
} as const

export type AdminUserStatus = (typeof AdminUserStatus)[keyof typeof AdminUserStatus]

export const AgentRunStatus = {
  CANCELED: 'CANCELED',
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED',
  IN_PROGRESS: 'IN_PROGRESS',
} as const

export type AgentRunStatus = (typeof AgentRunStatus)[keyof typeof AgentRunStatus]

export const AggregationOperation = {
  AVG: 'AVG',
  COUNT: 'COUNT',
  DISTINCT_COUNT: 'DISTINCT_COUNT',
  MAX: 'MAX',
  MEDIAN: 'MEDIAN',
  MIN: 'MIN',
  RANGE: 'RANGE',
  SUM: 'SUM',
} as const

export type AggregationOperation = (typeof AggregationOperation)[keyof typeof AggregationOperation]

export const ApplicationOrientation = {
  LEFT_TO_RIGHT: 'LEFT_TO_RIGHT',
  RIGHT_TO_LEFT: 'RIGHT_TO_LEFT',
} as const

export type ApplicationOrientation =
  (typeof ApplicationOrientation)[keyof typeof ApplicationOrientation]

export const BooleanOperator = {
  AND: 'AND',
  OR: 'OR',
} as const

export type BooleanOperator = (typeof BooleanOperator)[keyof typeof BooleanOperator]

export const CalendarUnit = {
  DAY: 'DAY',
  HOUR: 'HOUR',
  MINUTE: 'MINUTE',
  MONTH: 'MONTH',
  QUARTER: 'QUARTER',
  WEEK: 'WEEK',
  YEAR: 'YEAR',
} as const

export type CalendarUnit = (typeof CalendarUnit)[keyof typeof CalendarUnit]

export const ChartGroupBySortType = {
  AGGREGATION: 'AGGREGATION',
  HEADERS: 'HEADERS',
} as const

export type ChartGroupBySortType = (typeof ChartGroupBySortType)[keyof typeof ChartGroupBySortType]

export const ChartGroupByType = {
  DEFAULT: 'DEFAULT',
  PIVOT: 'PIVOT',
} as const

export type ChartGroupByType = (typeof ChartGroupByType)[keyof typeof ChartGroupByType]

export const ChartType = {
  BAR: 'BAR',
  LINE: 'LINE',
  METRIC: 'METRIC',
  PIE: 'PIE',
  PIVOT_TABLE: 'PIVOT_TABLE',
  SCATTERPLOT: 'SCATTERPLOT',
} as const

export type ChartType = (typeof ChartType)[keyof typeof ChartType]

export const ChartValueDisplayType = {
  PERCENT_OF_COLUMN: 'PERCENT_OF_COLUMN',
  PERCENT_OF_GRAND_TOTAL: 'PERCENT_OF_GRAND_TOTAL',
  PERCENT_OF_ROW: 'PERCENT_OF_ROW',
  RAW_VALUE: 'RAW_VALUE',
} as const

export type ChartValueDisplayType =
  (typeof ChartValueDisplayType)[keyof typeof ChartValueDisplayType]

export const ComprehensionEdgeType = {
  DATA_FLOW: 'DATA_FLOW',
  MONITOR: 'MONITOR',
  READ: 'READ',
  STRUCTURAL: 'STRUCTURAL',
  WRITE: 'WRITE',
} as const

export type ComprehensionEdgeType =
  (typeof ComprehensionEdgeType)[keyof typeof ComprehensionEdgeType]

export const ComprehensionEntityType = {
  ACTION: 'ACTION',
  ACTION_STEP: 'ACTION_STEP',
  ACTION_STEP_GROUP: 'ACTION_STEP_GROUP',
  AUTO_TRIGGER: 'AUTO_TRIGGER',
  FORM: 'FORM',
  FORM_FIELD: 'FORM_FIELD',
  FORM_INPUT: 'FORM_INPUT',
  FORM_V2: 'FORM_V2',
  INTEGRATION: 'INTEGRATION',
  MANUAL_TRIGGER: 'MANUAL_TRIGGER',
  TABLE: 'TABLE',
  TABLE_COLUMN: 'TABLE_COLUMN',
  WORKFLOW_V2: 'WORKFLOW_V2',
} as const

export type ComprehensionEntityType =
  (typeof ComprehensionEntityType)[keyof typeof ComprehensionEntityType]

export const Currency = {
  AUD: 'AUD',
  CAD: 'CAD',
  EUR: 'EUR',
  GBP: 'GBP',
  HKD: 'HKD',
  ILS: 'ILS',
  MYR: 'MYR',
  NZD: 'NZD',
  SGD: 'SGD',
  USD: 'USD',
} as const

export type Currency = (typeof Currency)[keyof typeof Currency]

export const DataStoreVariableType = {
  ARRAY_NUMBER: 'ARRAY_NUMBER',
  ARRAY_STRING: 'ARRAY_STRING',
  BOOLEAN: 'BOOLEAN',
  NUMBER: 'NUMBER',
  STRING: 'STRING',
} as const

export type DataStoreVariableType =
  (typeof DataStoreVariableType)[keyof typeof DataStoreVariableType]

export const DataType = {
  ARRAY: 'ARRAY',
  BOOLEAN: 'BOOLEAN',
  DATE: 'DATE',
  DATE_TIME: 'DATE_TIME',
  ENUM: 'ENUM',
  FILE_URL: 'FILE_URL',
  FORMULA: 'FORMULA',
  FORMULA_BOOLEAN: 'FORMULA_BOOLEAN',
  FORMULA_DATE: 'FORMULA_DATE',
  FORMULA_DATE_TIME: 'FORMULA_DATE_TIME',
  FORMULA_NUMBER: 'FORMULA_NUMBER',
  FORMULA_STRING: 'FORMULA_STRING',
  ID: 'ID',
  LOOKUP: 'LOOKUP',
  NUMBER: 'NUMBER',
  STRING: 'STRING',
  USER: 'USER',
} as const

export type DataType = (typeof DataType)[keyof typeof DataType]

export const DayOfWeek = {
  Friday: 'Friday',
  Monday: 'Monday',
  Saturday: 'Saturday',
  Sunday: 'Sunday',
  Thursday: 'Thursday',
  Tuesday: 'Tuesday',
  Wednesday: 'Wednesday',
} as const

export type DayOfWeek = (typeof DayOfWeek)[keyof typeof DayOfWeek]

export const DocumentType = {
  AI: 'AI',
  CSV: 'CSV',
  DOC: 'DOC',
  DOCX: 'DOCX',
  DWG: 'DWG',
  GIF: 'GIF',
  HTML: 'HTML',
  JPEG: 'JPEG',
  JPG: 'JPG',
  PDF: 'PDF',
  PNG: 'PNG',
  PPT: 'PPT',
  PPTX: 'PPTX',
  SIF: 'SIF',
  STEP: 'STEP',
  SVG: 'SVG',
  THREEDM: 'THREEDM',
  TXT: 'TXT',
  WEBP: 'WEBP',
  XLS: 'XLS',
  XLSM: 'XLSM',
  XLSX: 'XLSX',
  ZIP: 'ZIP',
  ZPL: 'ZPL',
} as const

export type DocumentType = (typeof DocumentType)[keyof typeof DocumentType]

export const DossbotChatRunStatus = {
  CANCELED: 'CANCELED',
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED',
  IN_PROGRESS: 'IN_PROGRESS',
} as const

export type DossbotChatRunStatus = (typeof DossbotChatRunStatus)[keyof typeof DossbotChatRunStatus]

export const DossbotEventType = {
  AGENT_RUN_CANCELED: 'AGENT_RUN_CANCELED',
  AGENT_RUN_COMPLETED: 'AGENT_RUN_COMPLETED',
  AGENT_RUN_FAILED: 'AGENT_RUN_FAILED',
  AGENT_RUN_STARTED: 'AGENT_RUN_STARTED',
  CHAT_RUN_CANCELED: 'CHAT_RUN_CANCELED',
  CHAT_RUN_COMPLETED: 'CHAT_RUN_COMPLETED',
  CHAT_RUN_FAILED: 'CHAT_RUN_FAILED',
  CHAT_RUN_STARTED: 'CHAT_RUN_STARTED',
  CHAT_SUMMARY_UPDATED: 'CHAT_SUMMARY_UPDATED',
  CHAT_TITLE_UPDATED: 'CHAT_TITLE_UPDATED',
  TOOL_RUN_APPROVED: 'TOOL_RUN_APPROVED',
  TOOL_RUN_CANCELED: 'TOOL_RUN_CANCELED',
  TOOL_RUN_COMPLETED: 'TOOL_RUN_COMPLETED',
  TOOL_RUN_FAILED: 'TOOL_RUN_FAILED',
  TOOL_RUN_PENDING: 'TOOL_RUN_PENDING',
  TOOL_RUN_REJECTED: 'TOOL_RUN_REJECTED',
  TOOL_RUN_STARTED: 'TOOL_RUN_STARTED',
} as const

export type DossbotEventType = (typeof DossbotEventType)[keyof typeof DossbotEventType]

export const EndpointIdempotencyKeyStatus = {
  COMPLETED: 'COMPLETED',
  IN_PROGRESS: 'IN_PROGRESS',
} as const

export type EndpointIdempotencyKeyStatus =
  (typeof EndpointIdempotencyKeyStatus)[keyof typeof EndpointIdempotencyKeyStatus]

export const EntityVersionHistoryEntityType = {
  ACTION: 'ACTION',
  FORM_V2: 'FORM_V2',
  TABLE: 'TABLE',
} as const

export type EntityVersionHistoryEntityType =
  (typeof EntityVersionHistoryEntityType)[keyof typeof EntityVersionHistoryEntityType]

export const EnumColorPreset = {
  BLUE: 'BLUE',
  GRAY: 'GRAY',
  GREEN: 'GREEN',
  ORANGE: 'ORANGE',
  PURPLE: 'PURPLE',
  RED: 'RED',
  YELLOW: 'YELLOW',
} as const

export type EnumColorPreset = (typeof EnumColorPreset)[keyof typeof EnumColorPreset]

export const EventType = {
  ACTION_END: 'ACTION_END',
  ACTION_START: 'ACTION_START',
  ACTION_STEP_NOTIFICATION: 'ACTION_STEP_NOTIFICATION',
  CREATE_CHART: 'CREATE_CHART',
  CREATE_DOCUMENT: 'CREATE_DOCUMENT',
  CREATE_TABLE: 'CREATE_TABLE',
  CREATE_TABLE_COLUMN: 'CREATE_TABLE_COLUMN',
  CREATE_TABLE_ROW: 'CREATE_TABLE_ROW',
  CREATE_TABLE_TAB: 'CREATE_TABLE_TAB',
  DELETE_CHART: 'DELETE_CHART',
  DELETE_DOCUMENT: 'DELETE_DOCUMENT',
  DELETE_TABLE: 'DELETE_TABLE',
  DELETE_TABLE_COLUMN: 'DELETE_TABLE_COLUMN',
  DELETE_TABLE_ROW: 'DELETE_TABLE_ROW',
  DELETE_TABLE_TAB: 'DELETE_TABLE_TAB',
  UPDATE_CHART: 'UPDATE_CHART',
  UPDATE_DOCUMENT: 'UPDATE_DOCUMENT',
  UPDATE_TABLE_CELL: 'UPDATE_TABLE_CELL',
  UPDATE_TABLE_COLUMN: 'UPDATE_TABLE_COLUMN',
  UPDATE_TABLE_ROW: 'UPDATE_TABLE_ROW',
  UPDATE_TABLE_TAB: 'UPDATE_TABLE_TAB',
} as const

export type EventType = (typeof EventType)[keyof typeof EventType]

export const ExecutionInstanceStatus = {
  FAILED: 'FAILED',
  QUEUED: 'QUEUED',
  RUNNING: 'RUNNING',
  SUCCEEDED: 'SUCCEEDED',
} as const

export type ExecutionInstanceStatus =
  (typeof ExecutionInstanceStatus)[keyof typeof ExecutionInstanceStatus]

export const ExecutionInstanceType = {
  ACTION: 'ACTION',
  ACTION_STEP: 'ACTION_STEP',
  ACTION_STEP_GROUP: 'ACTION_STEP_GROUP',
  ACTION_STEP_WAIT: 'ACTION_STEP_WAIT',
  API_TRIGGER: 'API_TRIGGER',
  AUTO_TRIGGER: 'AUTO_TRIGGER',
  FREQUENCY_TRIGGER: 'FREQUENCY_TRIGGER',
  MANUAL_TRIGGER: 'MANUAL_TRIGGER',
} as const

export type ExecutionInstanceType =
  (typeof ExecutionInstanceType)[keyof typeof ExecutionInstanceType]

export const ExportBackend = {
  BULLMQ: 'BULLMQ',
  RESTATE: 'RESTATE',
} as const

export type ExportBackend = (typeof ExportBackend)[keyof typeof ExportBackend]

export const FilterOperator = {
  CONTAINS: 'CONTAINS',
  DOES_NOT_CONTAIN: 'DOES_NOT_CONTAIN',
  ENDS_WITH: 'ENDS_WITH',
  EQUALS: 'EQUALS',
  GREATER_THAN: 'GREATER_THAN',
  GREATER_THAN_OR_EQUAL_TO: 'GREATER_THAN_OR_EQUAL_TO',
  IN: 'IN',
  IS_ANY_OF: 'IS_ANY_OF',
  IS_DUPLICATE: 'IS_DUPLICATE',
  IS_EMPTY: 'IS_EMPTY',
  IS_NONE_OF: 'IS_NONE_OF',
  IS_NOT_EMPTY: 'IS_NOT_EMPTY',
  IS_NOT_EQUAL_TO: 'IS_NOT_EQUAL_TO',
  LESS_THAN: 'LESS_THAN',
  LESS_THAN_OR_EQUAL_TO: 'LESS_THAN_OR_EQUAL_TO',
  NOT_IN: 'NOT_IN',
  NOT_IN_RANGE: 'NOT_IN_RANGE',
  RANGE: 'RANGE',
  STARTS_WITH: 'STARTS_WITH',
} as const

export type FilterOperator = (typeof FilterOperator)[keyof typeof FilterOperator]

export const FilterableObjectType = {
  CHART: 'CHART',
  TABLE_TAB: 'TABLE_TAB',
} as const

export type FilterableObjectType = (typeof FilterableObjectType)[keyof typeof FilterableObjectType]

export const FormBlockType = {
  DIVIDER: 'DIVIDER',
  INPUT: 'INPUT',
  ROW: 'ROW',
  SECTION: 'SECTION',
  TABLE: 'TABLE',
  TEXT_ELEMENT: 'TEXT_ELEMENT',
} as const

export type FormBlockType = (typeof FormBlockType)[keyof typeof FormBlockType]

export const FormFieldType = {
  BOOLEAN: 'BOOLEAN',
  CHECKBOXES: 'CHECKBOXES',
  DATE: 'DATE',
  DATE_TIME: 'DATE_TIME',
  DROPDOWN: 'DROPDOWN',
  EMAIL: 'EMAIL',
  FILE: 'FILE',
  LOCATION: 'LOCATION',
  LONG_TEXT: 'LONG_TEXT',
  NUMBER: 'NUMBER',
  RADIO_BUTTON: 'RADIO_BUTTON',
  SHORT_TEXT: 'SHORT_TEXT',
  SIGNATURE: 'SIGNATURE',
} as const

export type FormFieldType = (typeof FormFieldType)[keyof typeof FormFieldType]

export const FormInputType = {
  BOOLEAN: 'BOOLEAN',
  CHECKBOXES: 'CHECKBOXES',
  DATE: 'DATE',
  DATE_TIME: 'DATE_TIME',
  DROPDOWN: 'DROPDOWN',
  EMAIL: 'EMAIL',
  FILE: 'FILE',
  FORMULA: 'FORMULA',
  LONG_TEXT: 'LONG_TEXT',
  LOOKUP: 'LOOKUP',
  NUMBER: 'NUMBER',
  PHONE_NUMBER: 'PHONE_NUMBER',
  RADIO_BUTTON: 'RADIO_BUTTON',
  SHORT_TEXT: 'SHORT_TEXT',
  SIGNATURE: 'SIGNATURE',
  URL: 'URL',
  USER: 'USER',
} as const

export type FormInputType = (typeof FormInputType)[keyof typeof FormInputType]

export const FormRedirectTarget = {
  BROWSER_BACK_LEGACY: 'BROWSER_BACK_LEGACY',
  CUSTOM_PATH: 'CUSTOM_PATH',
  FORMS_HOME: 'FORMS_HOME',
  HOME: 'HOME',
  STAY_ON_FORM: 'STAY_ON_FORM',
} as const

export type FormRedirectTarget = (typeof FormRedirectTarget)[keyof typeof FormRedirectTarget]

export const FormatPreset = {
  DATE_CUSTOM: 'DATE_CUSTOM',
  NUMBER_CURRENCY: 'NUMBER_CURRENCY',
  NUMBER_DECIMAL: 'NUMBER_DECIMAL',
  NUMBER_INTEGER: 'NUMBER_INTEGER',
  NUMBER_PERCENT: 'NUMBER_PERCENT',
  NUMBER_PLAIN: 'NUMBER_PLAIN',
  NUMBER_UNIT: 'NUMBER_UNIT',
} as const

export type FormatPreset = (typeof FormatPreset)[keyof typeof FormatPreset]

export const FormulaOperator = {
  ADDITION: 'ADDITION',
  AND: 'AND',
  AVERAGE: 'AVERAGE',
  CEIL: 'CEIL',
  CONCAT: 'CONCAT',
  CONTAINS: 'CONTAINS',
  CONTAINS_ALL: 'CONTAINS_ALL',
  CONTAINS_ANY: 'CONTAINS_ANY',
  COUNT: 'COUNT',
  COUNT_DISTINCT: 'COUNT_DISTINCT',
  DATE: 'DATE',
  DATEADD: 'DATEADD',
  DATEDIFF: 'DATEDIFF',
  DAY: 'DAY',
  DIVISION: 'DIVISION',
  DOES_NOT_CONTAIN: 'DOES_NOT_CONTAIN',
  DOES_NOT_CONTAIN_ANY: 'DOES_NOT_CONTAIN_ANY',
  EQUAL: 'EQUAL',
  FLOOR: 'FLOOR',
  GREATER_THAN: 'GREATER_THAN',
  GREATER_THAN_OR_EQUAL: 'GREATER_THAN_OR_EQUAL',
  IN: 'IN',
  IS_EMPTY: 'IS_EMPTY',
  IS_NOT_EMPTY: 'IS_NOT_EMPTY',
  LEFT: 'LEFT',
  LEN: 'LEN',
  LESS_THAN: 'LESS_THAN',
  LESS_THAN_OR_EQUAL: 'LESS_THAN_OR_EQUAL',
  LOWER: 'LOWER',
  MAX: 'MAX',
  MID: 'MID',
  MIN: 'MIN',
  MONTH: 'MONTH',
  MULTIPLICATION: 'MULTIPLICATION',
  NOT: 'NOT',
  NOT_EQUAL: 'NOT_EQUAL',
  NOT_IN: 'NOT_IN',
  OR: 'OR',
  RIGHT: 'RIGHT',
  ROUND: 'ROUND',
  SUBSTITUTE: 'SUBSTITUTE',
  SUBTRACTION: 'SUBTRACTION',
  SUM: 'SUM',
  SUMPRODUCT: 'SUMPRODUCT',
  TO_DATE: 'TO_DATE',
  TO_NUMBER: 'TO_NUMBER',
  TO_TEXT: 'TO_TEXT',
  TRIM: 'TRIM',
  UPPER: 'UPPER',
  YEAR: 'YEAR',
} as const

export type FormulaOperator = (typeof FormulaOperator)[keyof typeof FormulaOperator]

export const GeneratedFileType = {
  ABA_REPORT_INSPECTION: 'ABA_REPORT_INSPECTION',
  ARK_FOODS_BILL_OF_LADING: 'ARK_FOODS_BILL_OF_LADING',
  ARK_FOODS_INVOICE: 'ARK_FOODS_INVOICE',
  ARK_FOODS_ORDER_CONFIRMATION: 'ARK_FOODS_ORDER_CONFIRMATION',
  ARK_FOODS_PASSING_SHEET: 'ARK_FOODS_PASSING_SHEET',
  ARK_FOODS_PURCHASE_ORDER: 'ARK_FOODS_PURCHASE_ORDER',
  ARK_FOODS_QC_INSPECTION: 'ARK_FOODS_QC_INSPECTION',
  ARK_FOODS_TRADER_JOES_PACKING_SLIP: 'ARK_FOODS_TRADER_JOES_PACKING_SLIP',
  ATHENA_CLUB_BOM_EXPORT_XLSX: 'ATHENA_CLUB_BOM_EXPORT_XLSX',
  ATHENA_CLUB_CO_MAN_EOM_INVENTORY_RECONCILIATION_XLSX:
    'ATHENA_CLUB_CO_MAN_EOM_INVENTORY_RECONCILIATION_XLSX',
  ATHENA_CLUB_PURCHASE_ORDER: 'ATHENA_CLUB_PURCHASE_ORDER',
  BALANCE_SHEET: 'BALANCE_SHEET',
  BALANCE_SHEET_SINGLE_PERIOD_XLSX: 'BALANCE_SHEET_SINGLE_PERIOD_XLSX',
  BILLING_STATEMENT: 'BILLING_STATEMENT',
  BIOM_GENERIC_GS1_128_LABEL: 'BIOM_GENERIC_GS1_128_LABEL',
  BIOM_GENERIC_PACKING_LIST: 'BIOM_GENERIC_PACKING_LIST',
  BIOM_GROVE_CASE_PACK_LABEL: 'BIOM_GROVE_CASE_PACK_LABEL',
  BIOM_GROVE_MULTI_SKU_PALLET_LABEL: 'BIOM_GROVE_MULTI_SKU_PALLET_LABEL',
  BIOM_GROVE_ONE_SKU_PALLET_LABEL: 'BIOM_GROVE_ONE_SKU_PALLET_LABEL',
  BIOM_GROVE_PACKING_LIST: 'BIOM_GROVE_PACKING_LIST',
  BIOM_INVOICE: 'BIOM_INVOICE',
  BIOM_LICENSE_PLATE_LABEL: 'BIOM_LICENSE_PLATE_LABEL',
  BIOM_TARGET_CARTON_SSCC_LABEL: 'BIOM_TARGET_CARTON_SSCC_LABEL',
  BIOM_TARGET_PACKING_LIST: 'BIOM_TARGET_PACKING_LIST',
  BIOM_TARGET_PALLET_SSCC_LABEL: 'BIOM_TARGET_PALLET_SSCC_LABEL',
  BIOM_THRIVE_PACKING_LIST: 'BIOM_THRIVE_PACKING_LIST',
  BIOM_THRIVE_SSCC_LABEL: 'BIOM_THRIVE_SSCC_LABEL',
  BIOM_UNFI_PACKING_LIST: 'BIOM_UNFI_PACKING_LIST',
  BIOM_UNFI_PALLET_PLACARD: 'BIOM_UNFI_PALLET_PLACARD',
  BIOM_VICS_BILL_OF_LADING: 'BIOM_VICS_BILL_OF_LADING',
  BIOM_VICS_MASTER_BILL_OF_LADING: 'BIOM_VICS_MASTER_BILL_OF_LADING',
  BIOM_WAREHOUSE_ADDRESS_LABEL: 'BIOM_WAREHOUSE_ADDRESS_LABEL',
  BIOM_WAREHOUSE_PICKING_SLIP: 'BIOM_WAREHOUSE_PICKING_SLIP',
  BNZ_BRIEFING: 'BNZ_BRIEFING',
  BNZ_EMPLOYEE_SAFETY: 'BNZ_EMPLOYEE_SAFETY',
  BNZ_PROJECT_SUBMISSION: 'BNZ_PROJECT_SUBMISSION',
  BNZ_WORK_DIARY: 'BNZ_WORK_DIARY',
  CAULIPUFFS_COPACK_PURCHASE_ORDER: 'CAULIPUFFS_COPACK_PURCHASE_ORDER',
  CAULIPUFFS_INVOICE: 'CAULIPUFFS_INVOICE',
  COMMERCIAL_INVOICE: 'COMMERCIAL_INVOICE',
  CREDIT_MEMO: 'CREDIT_MEMO',
  CSV: 'CSV',
  DENIM_TEARS_PURCHASE_ORDER: 'DENIM_TEARS_PURCHASE_ORDER',
  DENIM_TEARS_PURCHASE_ORDER_V2: 'DENIM_TEARS_PURCHASE_ORDER_V2',
  DE_SOI_PRODUCT_INFORMATION_WORKSHEET_CAN_XLSX: 'DE_SOI_PRODUCT_INFORMATION_WORKSHEET_CAN_XLSX',
  DE_SOI_PURCHASE_ORDER: 'DE_SOI_PURCHASE_ORDER',
  DIVERSIFIED_BOTANICALS_INVENTORY_LABEL: 'DIVERSIFIED_BOTANICALS_INVENTORY_LABEL',
  DIVERSIFIED_BOTANICALS_PURCHASE_ORDER: 'DIVERSIFIED_BOTANICALS_PURCHASE_ORDER',
  DIVERSIFIED_BOTANICALS_SALES_ORDER: 'DIVERSIFIED_BOTANICALS_SALES_ORDER',
  DNB_PURCHASE_ORDER: 'DNB_PURCHASE_ORDER',
  EIGHT_SLEEP_PURCHASE_ORDER: 'EIGHT_SLEEP_PURCHASE_ORDER',
  EIGHT_SLEEP_PURCHASE_ORDER_BILINGUAL: 'EIGHT_SLEEP_PURCHASE_ORDER_BILINGUAL',
  EIGHT_SLEEP_PURCHASE_ORDER_RMB: 'EIGHT_SLEEP_PURCHASE_ORDER_RMB',
  FACTOR_FORM_PURCHASE_ORDER: 'FACTOR_FORM_PURCHASE_ORDER',
  FIRSTBASE_CP_RECEIPT: 'FIRSTBASE_CP_RECEIPT',
  FIRSTBASE_PO_IMPORT: 'FIRSTBASE_PO_IMPORT',
  FIRSTBASE_PURCHASE_ORDER: 'FIRSTBASE_PURCHASE_ORDER',
  FIRSTBASE_REQUEST_FOR_QUOTE: 'FIRSTBASE_REQUEST_FOR_QUOTE',
  GG_PURCHASE_ORDER_XLSX: 'GG_PURCHASE_ORDER_XLSX',
  GRACE_FARMS_PACKING_SLIP: 'GRACE_FARMS_PACKING_SLIP',
  INCOME_STATEMENT: 'INCOME_STATEMENT',
  INCOME_STATEMENT_SINGLE_PERIOD_XLSX: 'INCOME_STATEMENT_SINGLE_PERIOD_XLSX',
  INCOME_STATEMENT_XLSX: 'INCOME_STATEMENT_XLSX',
  INSTANT_HYDRATION_PURCHASE_ORDER: 'INSTANT_HYDRATION_PURCHASE_ORDER',
  INVOICE: 'INVOICE',
  K1893_FREIGHT_QUOTE: 'K1893_FREIGHT_QUOTE',
  K1893_INVOICE: 'K1893_INVOICE',
  K1893_INVOICE_MEIJER: 'K1893_INVOICE_MEIJER',
  K1893_INVOICE_TJS: 'K1893_INVOICE_TJS',
  K1893_INVOICE_UNFI: 'K1893_INVOICE_UNFI',
  K1893_PALLET_INSTRUCTIONS: 'K1893_PALLET_INSTRUCTIONS',
  K1893_PURCHASE_ORDER: 'K1893_PURCHASE_ORDER',
  K1893_PURCHASE_ORDER_OVG: 'K1893_PURCHASE_ORDER_OVG',
  LITTLE_BEAST_PURCHASE_ORDER: 'LITTLE_BEAST_PURCHASE_ORDER',
  MAGIC_MIND_PACKING_SLIP: 'MAGIC_MIND_PACKING_SLIP',
  MAGIC_MIND_PURCHASE_ORDER: 'MAGIC_MIND_PURCHASE_ORDER',
  MEZCLA_PACKING_LIST: 'MEZCLA_PACKING_LIST',
  MEZCLA_PURCHASE_ORDER: 'MEZCLA_PURCHASE_ORDER',
  MEZCLA_PURCHASE_ORDER_V2: 'MEZCLA_PURCHASE_ORDER_V2',
  NOODLES_COMPLAINT: 'NOODLES_COMPLAINT',
  NOODLES_CREDIT_NOTE: 'NOODLES_CREDIT_NOTE',
  NOODLES_DELIVERY_NOTE: 'NOODLES_DELIVERY_NOTE',
  NOODLES_INVOICE: 'NOODLES_INVOICE',
  NOODLES_MIDABO_SUPPLIER_ORDER: 'NOODLES_MIDABO_SUPPLIER_ORDER',
  NOODLES_ORDER: 'NOODLES_ORDER',
  NOODLES_QUOTE: 'NOODLES_QUOTE',
  NOODLES_SUPPLIER_ORDER: 'NOODLES_SUPPLIER_ORDER',
  PALLET_LABEL: 'PALLET_LABEL',
  PAVOI_COMMERCIAL_INVOICE: 'PAVOI_COMMERCIAL_INVOICE',
  PICK_TICKET: 'PICK_TICKET',
  POPDARTS_COMMISSION_INVOICE_XLSX: 'POPDARTS_COMMISSION_INVOICE_XLSX',
  PURCHASE_ORDER: 'PURCHASE_ORDER',
  PURCHASE_ORDER_V2: 'PURCHASE_ORDER_V2',
  PURCHASE_ORDER_V3: 'PURCHASE_ORDER_V3',
  PURCHASE_ORDER_V4: 'PURCHASE_ORDER_V4',
  QUOTE: 'QUOTE',
  REFLOR_PURCHASE_ORDER: 'REFLOR_PURCHASE_ORDER',
  REFLOR_WORK_ORDER: 'REFLOR_WORK_ORDER',
  REMITTANCE_ADVICE: 'REMITTANCE_ADVICE',
  SALES_ORDER: 'SALES_ORDER',
  SELKIRK_PURCHASE_ORDER: 'SELKIRK_PURCHASE_ORDER',
  SL_MUNSON_1099_FORM: 'SL_MUNSON_1099_FORM',
  SL_MUNSON_PACKING_SLIP: 'SL_MUNSON_PACKING_SLIP',
  SMASH_FOODS_BLANKET_PURCHASE_ORDER: 'SMASH_FOODS_BLANKET_PURCHASE_ORDER',
  SMASH_FOODS_PURCHASE_ORDER: 'SMASH_FOODS_PURCHASE_ORDER',
  SNACKWISE_INVOICE: 'SNACKWISE_INVOICE',
  SNACKWISE_PICK_TICKET: 'SNACKWISE_PICK_TICKET',
  SOS_BUDGET: 'SOS_BUDGET',
  SOS_PROPOSAL: 'SOS_PROPOSAL',
  SOURCIFY_CUSTOMER_QUOTE_APPROVAL: 'SOURCIFY_CUSTOMER_QUOTE_APPROVAL',
  SOURCIFY_CUSTOMER_QUOTE_DETAILS_APPROVAL: 'SOURCIFY_CUSTOMER_QUOTE_DETAILS_APPROVAL',
  SOURCIFY_REQUEST_FOR_PRICING: 'SOURCIFY_REQUEST_FOR_PRICING',
  STL_PACKING_SLIP: 'STL_PACKING_SLIP',
  STL_PURCHASE_ORDER: 'STL_PURCHASE_ORDER',
  SUPERHUMN_IMPORTER_SECURITY_FILING: 'SUPERHUMN_IMPORTER_SECURITY_FILING',
  TAGWALL_ACCOUNTS_PAYABLE_AGING_XLSX: 'TAGWALL_ACCOUNTS_PAYABLE_AGING_XLSX',
  TAGWALL_ACCOUNTS_RECEIVABLE_AGING_XLSX: 'TAGWALL_ACCOUNTS_RECEIVABLE_AGING_XLSX',
  TAGWALL_BILL_OF_LADING: 'TAGWALL_BILL_OF_LADING',
  TAGWALL_CONFIGURABLE_REPORT_XLSX: 'TAGWALL_CONFIGURABLE_REPORT_XLSX',
  TAGWALL_DELIVERY_TICKET: 'TAGWALL_DELIVERY_TICKET',
  TAGWALL_INVOICE: 'TAGWALL_INVOICE',
  TAGWALL_PICK_TICKET: 'TAGWALL_PICK_TICKET',
  TAGWALL_PURCHASE_ORDER: 'TAGWALL_PURCHASE_ORDER',
  TAGWALL_RECEIVING_TICKET: 'TAGWALL_RECEIVING_TICKET',
  TERSUS_CONTAINER_BARCODE: 'TERSUS_CONTAINER_BARCODE',
  TOOM_PURCHASE_ORDER_PROCUREMENT: 'TOOM_PURCHASE_ORDER_PROCUREMENT',
  TOOM_PURCHASE_ORDER_PRODUCTION: 'TOOM_PURCHASE_ORDER_PRODUCTION',
  VERVE_COFFEE_CERTIFICATE_OF_ANALYSIS: 'VERVE_COFFEE_CERTIFICATE_OF_ANALYSIS',
  VERVE_COFFEE_PICK_TICKET: 'VERVE_COFFEE_PICK_TICKET',
  VERVE_COFFEE_PICK_TICKET_BARCODE: 'VERVE_COFFEE_PICK_TICKET_BARCODE',
  VERVE_COFFEE_REQUEST_FOR_COFFEE_PROCUREMENT: 'VERVE_COFFEE_REQUEST_FOR_COFFEE_PROCUREMENT',
  VERVE_COFFEE_SALES_ORDER_SHIPPING_LABEL: 'VERVE_COFFEE_SALES_ORDER_SHIPPING_LABEL',
  VERVE_COFFEE_SUPERSACK_LABEL: 'VERVE_COFFEE_SUPERSACK_LABEL',
  VERVE_COFFEE_TRANSFER_SHIPPING_LABEL: 'VERVE_COFFEE_TRANSFER_SHIPPING_LABEL',
  WORK_ORDER: 'WORK_ORDER',
} as const

export type GeneratedFileType = (typeof GeneratedFileType)[keyof typeof GeneratedFileType]

export const IndexType = {
  NONE: 'NONE',
  NUMBER: 'NUMBER',
  STRING: 'STRING',
} as const

export type IndexType = (typeof IndexType)[keyof typeof IndexType]

export const IntegrationSyncStatus = {
  CANCELED: 'CANCELED',
  ERROR: 'ERROR',
  NOT_PROCESSED: 'NOT_PROCESSED',
  PENDING: 'PENDING',
  SUCCESS: 'SUCCESS',
  SYNCING: 'SYNCING',
} as const

export type IntegrationSyncStatus =
  (typeof IntegrationSyncStatus)[keyof typeof IntegrationSyncStatus]

export const IntegrationType = {
  A2B_FULFILLMENT: 'A2B_FULFILLMENT',
  AIRTABLE: 'AIRTABLE',
  AMAZON_SELLER: 'AMAZON_SELLER',
  ARAMEX: 'ARAMEX',
  BEPRODUCT: 'BEPRODUCT',
  BILL: 'BILL',
  BREX: 'BREX',
  BRND_SUPPLIER: 'BRND_SUPPLIER',
  BRND_WHOLESALE: 'BRND_WHOLESALE',
  BUHO: 'BUHO',
  BYRD: 'BYRD',
  CAMPFIRE: 'CAMPFIRE',
  CARTONCLOUD: 'CARTONCLOUD',
  CROPSTER: 'CROPSTER',
  CRSTL: 'CRSTL',
  D2: 'D2',
  DEPOSCO: 'DEPOSCO',
  DOSS_BANKING: 'DOSS_BANKING',
  DOSS_BILL_PAY: 'DOSS_BILL_PAY',
  DOSS_EXCHANGE_RATES: 'DOSS_EXCHANGE_RATES',
  EASYPOST: 'EASYPOST',
  ECHO_SHIP: 'ECHO_SHIP',
  EXTENSIV: 'EXTENSIV',
  EXTRON: 'EXTRON',
  FAIRE: 'FAIRE',
  FENO: 'FENO',
  FIRSTBASE: 'FIRSTBASE',
  FLEXPORT: 'FLEXPORT',
  FORTY_SEAS: 'FORTY_SEAS',
  FOSDICK: 'FOSDICK',
  FTP: 'FTP',
  G2MINT: 'G2MINT',
  GMAIL: 'GMAIL',
  GNOSIS: 'GNOSIS',
  GOFREIGHT: 'GOFREIGHT',
  GOOGLE_CLOUD_STORAGE: 'GOOGLE_CLOUD_STORAGE',
  HTTP_ENDPOINT: 'HTTP_ENDPOINT',
  HUBSPOT: 'HUBSPOT',
  INGRAM_MICRO: 'INGRAM_MICRO',
  JAY_GROUP: 'JAY_GROUP',
  JAZZ: 'JAZZ',
  JIGSAW: 'JIGSAW',
  LAZADA: 'LAZADA',
  LOCAD: 'LOCAD',
  LOGIWA: 'LOGIWA',
  LOOP_RETURNS: 'LOOP_RETURNS',
  MAINFREIGHT: 'MAINFREIGHT',
  MARKETTIME: 'MARKETTIME',
  MAYA: 'MAYA',
  MEDUSA: 'MEDUSA',
  MINTSOFT: 'MINTSOFT',
  MISFITS_MARKET: 'MISFITS_MARKET',
  NAVISPHERE: 'NAVISPHERE',
  NETSUITE: 'NETSUITE',
  NOK_RECOMMERCE: 'NOK_RECOMMERCE',
  NTG_WMS: 'NTG_WMS',
  ONE_WORLD_DIRECT: 'ONE_WORLD_DIRECT',
  ORDERFUL: 'ORDERFUL',
  OUTLOOK: 'OUTLOOK',
  POSTGRES: 'POSTGRES',
  PRO_PAC: 'PRO_PAC',
  QUICKBOOKS: 'QUICKBOOKS',
  RAMP: 'RAMP',
  RAPID_PACK: 'RAPID_PACK',
  RILLET: 'RILLET',
  ROUTABLE: 'ROUTABLE',
  SALSIFY: 'SALSIFY',
  SHIPBOB: 'SHIPBOB',
  SHIPHERO: 'SHIPHERO',
  SHIPMONK: 'SHIPMONK',
  SHIPSIDEKICK: 'SHIPSIDEKICK',
  SHIPSTATION: 'SHIPSTATION',
  SHIPWIRE: 'SHIPWIRE',
  SHOPEE: 'SHOPEE',
  SHOPIFY: 'SHOPIFY',
  SILQ: 'SILQ',
  SNAPFULFIL: 'SNAPFULFIL',
  SPS_COMMERCE: 'SPS_COMMERCE',
  STORD: 'STORD',
  STRIPE: 'STRIPE',
  TD_SYNNEX: 'TD_SYNNEX',
  TD_SYNNEX_XML: 'TD_SYNNEX_XML',
  THINK_LOGISTICS: 'THINK_LOGISTICS',
  TIKTOK_SHOP: 'TIKTOK_SHOP',
  TOAST: 'TOAST',
  TQL_FREIGHT: 'TQL_FREIGHT',
  UNIS: 'UNIS',
  USA_SUPPLY: 'USA_SUPPLY',
  VERACORE: 'VERACORE',
  WALMART: 'WALMART',
  WAREHANCE: 'WAREHANCE',
  WESTERN_POST: 'WESTERN_POST',
  WOO_COMMERCE: 'WOO_COMMERCE',
  XERO: 'XERO',
} as const

export type IntegrationType = (typeof IntegrationType)[keyof typeof IntegrationType]

export const Locale = {
  DE_DE: 'DE_DE',
  EN_CA: 'EN_CA',
  EN_GB: 'EN_GB',
  EN_IE: 'EN_IE',
  EN_NZ: 'EN_NZ',
  EN_US: 'EN_US',
  ES_ES: 'ES_ES',
  ES_MX: 'ES_MX',
  FR_CA: 'FR_CA',
  FR_FR: 'FR_FR',
  HE_IL: 'HE_IL',
  NL_NL: 'NL_NL',
  ZH_HK: 'ZH_HK',
  ZH_SG: 'ZH_SG',
} as const

export type Locale = (typeof Locale)[keyof typeof Locale]

export const LogicExpressionCondition = {
  CONTAINS: 'CONTAINS',
  CONTAINS_ALL: 'CONTAINS_ALL',
  CONTAINS_ANY: 'CONTAINS_ANY',
  DOES_NOT_CONTAIN: 'DOES_NOT_CONTAIN',
  DOES_NOT_CONTAIN_ANY: 'DOES_NOT_CONTAIN_ANY',
  EQUAL: 'EQUAL',
  GREATER_THAN: 'GREATER_THAN',
  GREATER_THAN_OR_EQUAL: 'GREATER_THAN_OR_EQUAL',
  IN: 'IN',
  IS_EMPTY: 'IS_EMPTY',
  IS_NOT_EMPTY: 'IS_NOT_EMPTY',
  LESS_THAN: 'LESS_THAN',
  LESS_THAN_OR_EQUAL: 'LESS_THAN_OR_EQUAL',
  NOT_EQUAL: 'NOT_EQUAL',
  NOT_IN: 'NOT_IN',
} as const

export type LogicExpressionCondition =
  (typeof LogicExpressionCondition)[keyof typeof LogicExpressionCondition]

export const LogicExpressionType = {
  AND: 'AND',
  BOOLEAN: 'BOOLEAN',
  COMPARISON: 'COMPARISON',
  NOT: 'NOT',
  OR: 'OR',
  UNARY: 'UNARY',
} as const

export type LogicExpressionType = (typeof LogicExpressionType)[keyof typeof LogicExpressionType]

export const LogicalEntityKind = {
  APP: 'APP',
  CHART: 'CHART',
  COLUMN: 'COLUMN',
  CONNECTION: 'CONNECTION',
  DASHBOARD: 'DASHBOARD',
  ENDPOINT: 'ENDPOINT',
  FORM: 'FORM',
  LOOKUP_GROUP: 'LOOKUP_GROUP',
  ROOT_WORKSPACE: 'ROOT_WORKSPACE',
  STATE: 'STATE',
  TABLE: 'TABLE',
  TRIGGER: 'TRIGGER',
  WORKFLOW: 'WORKFLOW',
  WORKSPACE_BUTTON: 'WORKSPACE_BUTTON',
} as const

export type LogicalEntityKind = (typeof LogicalEntityKind)[keyof typeof LogicalEntityKind]

export const ModelProvider = {
  ANTHROPIC: 'ANTHROPIC',
  OPENAI: 'OPENAI',
} as const

export type ModelProvider = (typeof ModelProvider)[keyof typeof ModelProvider]

export const Month = {
  April: 'April',
  August: 'August',
  December: 'December',
  February: 'February',
  January: 'January',
  July: 'July',
  June: 'June',
  March: 'March',
  May: 'May',
  November: 'November',
  October: 'October',
  September: 'September',
} as const

export type Month = (typeof Month)[keyof typeof Month]

export const NavigationDestinationType = {
  APP: 'APP',
  DASHBOARD: 'DASHBOARD',
  ENDPOINT: 'ENDPOINT',
  FORM: 'FORM',
  LOOKUP_GROUP: 'LOOKUP_GROUP',
  TABLE: 'TABLE',
  TABLE_TAB: 'TABLE_TAB',
} as const

export type NavigationDestinationType =
  (typeof NavigationDestinationType)[keyof typeof NavigationDestinationType]

export const NodeType = {
  ACTION_STEP: 'ACTION_STEP',
  FORM_FIELD: 'FORM_FIELD',
  FORM_INPUT: 'FORM_INPUT',
  TABLE: 'TABLE',
  TABLE_COLUMN: 'TABLE_COLUMN',
} as const

export type NodeType = (typeof NodeType)[keyof typeof NodeType]

export const NotificationType = {
  ACTION_STEP_NOTIFICATION: 'ACTION_STEP_NOTIFICATION',
  ALERT: 'ALERT',
  MENTION: 'MENTION',
  THREAD_REPLY: 'THREAD_REPLY',
  WORKFLOW_V2_INVALIDATED: 'WORKFLOW_V2_INVALIDATED',
} as const

export type NotificationType = (typeof NotificationType)[keyof typeof NotificationType]

export const OAuth2TokenStatus = {
  AUTHORIZED: 'AUTHORIZED',
  EXPIRED: 'EXPIRED',
  PENDING: 'PENDING',
  REVOKED: 'REVOKED',
} as const

export type OAuth2TokenStatus = (typeof OAuth2TokenStatus)[keyof typeof OAuth2TokenStatus]

export const ObjectStoreTransferDirection = {
  EXPORT: 'EXPORT',
  IMPORT: 'IMPORT',
} as const

export type ObjectStoreTransferDirection =
  (typeof ObjectStoreTransferDirection)[keyof typeof ObjectStoreTransferDirection]

export const ObjectStoreTransferFileType = {
  CSV: 'CSV',
  PARQUET: 'PARQUET',
} as const

export type ObjectStoreTransferFileType =
  (typeof ObjectStoreTransferFileType)[keyof typeof ObjectStoreTransferFileType]

export const OrganizationExportStatus = {
  COMPLETED: 'COMPLETED',
  COMPLETED_WITH_ERRORS: 'COMPLETED_WITH_ERRORS',
  FAILED: 'FAILED',
  PENDING: 'PENDING',
  PROCESSING: 'PROCESSING',
  ZIPPING: 'ZIPPING',
} as const

export type OrganizationExportStatus =
  (typeof OrganizationExportStatus)[keyof typeof OrganizationExportStatus]

export const OrganizationStatus = {
  ACTIVE: 'ACTIVE',
  DEMO: 'DEMO',
  INACTIVE: 'INACTIVE',
  ONBOARDING: 'ONBOARDING',
} as const

export type OrganizationStatus = (typeof OrganizationStatus)[keyof typeof OrganizationStatus]

export const PermissionObjectType = {
  EMBED: 'EMBED',
  ENDPOINT: 'ENDPOINT',
  FORM: 'FORM',
  MANUAL_TRIGGER: 'MANUAL_TRIGGER',
  TABLE: 'TABLE',
  TABLE_COLUMN: 'TABLE_COLUMN',
  TABLE_TAB: 'TABLE_TAB',
  WORKSPACE: 'WORKSPACE',
} as const

export type PermissionObjectType = (typeof PermissionObjectType)[keyof typeof PermissionObjectType]

export const PermissionType = {
  ADD_ROW: 'ADD_ROW',
  CALL_ENDPOINT: 'CALL_ENDPOINT',
  CONFIGURE_PIVOT_TABLES: 'CONFIGURE_PIVOT_TABLES',
  CONFIGURE_TABLE_TABS: 'CONFIGURE_TABLE_TABS',
  DELETE_ROW: 'DELETE_ROW',
  EDIT_ALL_TABLE_CELLS: 'EDIT_ALL_TABLE_CELLS',
  EDIT_CELL: 'EDIT_CELL',
  EDIT_WORKSAPCE: 'EDIT_WORKSAPCE',
  SUBMIT_FORM: 'SUBMIT_FORM',
  SUBMIT_MANUAL_TRIGGER: 'SUBMIT_MANUAL_TRIGGER',
  VIEW_ALL_TABLE_CELLS: 'VIEW_ALL_TABLE_CELLS',
  VIEW_COLUMN: 'VIEW_COLUMN',
  VIEW_EMBED: 'VIEW_EMBED',
  VIEW_TABLE_TAB_ROWS: 'VIEW_TABLE_TAB_ROWS',
  VIEW_WORKSPACE: 'VIEW_WORKSPACE',
} as const

export type PermissionType = (typeof PermissionType)[keyof typeof PermissionType]

export const RoleType = {
  ADMIN: 'ADMIN',
  EXTERNAL: 'EXTERNAL',
  INTERNAL_DOSS: 'INTERNAL_DOSS',
  MEMBER: 'MEMBER',
} as const

export type RoleType = (typeof RoleType)[keyof typeof RoleType]

export const SortDirection = {
  ASC: 'ASC',
  DESC: 'DESC',
} as const

export type SortDirection = (typeof SortDirection)[keyof typeof SortDirection]

export const SystemConfigScopeType = {
  ORGANIZATION: 'ORGANIZATION',
} as const

export type SystemConfigScopeType =
  (typeof SystemConfigScopeType)[keyof typeof SystemConfigScopeType]

export const SystemGeneratedTableColumnType = {
  CREATED_AT: 'CREATED_AT',
  CREATED_BY: 'CREATED_BY',
  UPDATED_AT: 'UPDATED_AT',
  UPDATED_BY: 'UPDATED_BY',
} as const

export type SystemGeneratedTableColumnType =
  (typeof SystemGeneratedTableColumnType)[keyof typeof SystemGeneratedTableColumnType]

export const TableColumnStorageType = {
  COLUMN: 'COLUMN',
  JOIN_TABLE: 'JOIN_TABLE',
} as const

export type TableColumnStorageType =
  (typeof TableColumnStorageType)[keyof typeof TableColumnStorageType]

export const TableExportStatus = {
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED',
  PENDING: 'PENDING',
  PROCESSING: 'PROCESSING',
} as const

export type TableExportStatus = (typeof TableExportStatus)[keyof typeof TableExportStatus]

export const TableUniqueConstraintErrorCode = {
  DDL_TIMEOUT: 'DDL_TIMEOUT',
  INDEX_BUILD_FAILED: 'INDEX_BUILD_FAILED',
  INELIGIBLE: 'INELIGIBLE',
  PROBE_FAILED: 'PROBE_FAILED',
} as const

export type TableUniqueConstraintErrorCode =
  (typeof TableUniqueConstraintErrorCode)[keyof typeof TableUniqueConstraintErrorCode]

export const TableUniqueConstraintScope = {
  PARENT: 'PARENT',
  TABLE: 'TABLE',
} as const

export type TableUniqueConstraintScope =
  (typeof TableUniqueConstraintScope)[keyof typeof TableUniqueConstraintScope]

export const TableUniqueConstraintStatus = {
  ACTIVE: 'ACTIVE',
  BUILDING: 'BUILDING',
  CONFLICTED: 'CONFLICTED',
  DELETING: 'DELETING',
  ERROR: 'ERROR',
  VALIDATING: 'VALIDATING',
} as const

export type TableUniqueConstraintStatus =
  (typeof TableUniqueConstraintStatus)[keyof typeof TableUniqueConstraintStatus]

export const ToolRunStatus = {
  APPROVED: 'APPROVED',
  CANCELED: 'CANCELED',
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED',
  IN_PROGRESS: 'IN_PROGRESS',
  PENDING: 'PENDING',
  REJECTED: 'REJECTED',
} as const

export type ToolRunStatus = (typeof ToolRunStatus)[keyof typeof ToolRunStatus]

export const TriumvirateValidationMessageType = {
  ERROR: 'ERROR',
  WARNING: 'WARNING',
} as const

export type TriumvirateValidationMessageType =
  (typeof TriumvirateValidationMessageType)[keyof typeof TriumvirateValidationMessageType]

export const UserStatus = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
} as const

export type UserStatus = (typeof UserStatus)[keyof typeof UserStatus]

export const ViewableObjectType = {
  CHART: 'CHART',
  DOCUMENT: 'DOCUMENT',
  EMBED: 'EMBED',
  FORM_V2: 'FORM_V2',
  TABLE: 'TABLE',
  TABLE_ROW: 'TABLE_ROW',
  WORKSPACE: 'WORKSPACE',
} as const

export type ViewableObjectType = (typeof ViewableObjectType)[keyof typeof ViewableObjectType]

export const WorkflowStatus = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
} as const

export type WorkflowStatus = (typeof WorkflowStatus)[keyof typeof WorkflowStatus]

export const WorkflowV2DiagnosticSeverity = {
  ERROR: 'ERROR',
  WARNING: 'WARNING',
} as const

export type WorkflowV2DiagnosticSeverity =
  (typeof WorkflowV2DiagnosticSeverity)[keyof typeof WorkflowV2DiagnosticSeverity]

export const WorkflowV2DiagnosticSource = {
  DOSS: 'DOSS',
  ESLINT: 'ESLINT',
  TSC: 'TSC',
} as const

export type WorkflowV2DiagnosticSource =
  (typeof WorkflowV2DiagnosticSource)[keyof typeof WorkflowV2DiagnosticSource]

export const WorkflowV2IdempotencyKeyStatus = {
  CLAIMED: 'CLAIMED',
  SENT: 'SENT',
} as const

export type WorkflowV2IdempotencyKeyStatus =
  (typeof WorkflowV2IdempotencyKeyStatus)[keyof typeof WorkflowV2IdempotencyKeyStatus]

export const WorkflowV2VerificationStatus = {
  INVALID: 'INVALID',
  NEEDS_MIGRATION: 'NEEDS_MIGRATION',
  SKIPPED_NO_SOURCE: 'SKIPPED_NO_SOURCE',
  VERIFIED: 'VERIFIED',
} as const

export type WorkflowV2VerificationStatus =
  (typeof WorkflowV2VerificationStatus)[keyof typeof WorkflowV2VerificationStatus]
